import ChatMessageMention from "@/components/communications-chat-components/ChatMessageMention";
import { BoxProps } from "@mui/material";
import React from "react";

/**
 * @property mentioned Displayed name
 * @property externalId Core user externalId
 * */
type MatchedMention = {
  mentioned: string;
  externalId: string;
};

const CAPTURING_MENTIONS_REGEX = /@\[([A-Z a-zÀ-ÿ0-9]+)]\(([A-Za-z0-9]+)\)+/g;
const NON_CAPTURING_MENTIONS_REGEX = /@\[[A-Z a-zÀ-ÿ0-9]+]\([A-Za-z0-9]+\)+/g;

/**
 * Matches mentions on the form `@[__display__](__id__)`
 *
 * @param message
 */
export function matchMentions(message: string): MatchedMention[] {
  return Array.from(message.matchAll(CAPTURING_MENTIONS_REGEX), (m) => ({
    mentioned: m[1],
    externalId: m[2],
  }));
}

export function replaceMentions(message: string): string {
  return message.replaceAll(CAPTURING_MENTIONS_REGEX, "$1");
}

export function generateMentionNodes(
  message: string,
  matchedMentions: MatchedMention[],
  sx?: BoxProps["sx"]
): (string | React.JSX.Element)[] {
  if (matchedMentions.length < 1) return;
  const splitted = message.split(NON_CAPTURING_MENTIONS_REGEX);
  return splitted.flatMap((it, idx) => {
    if (idx === splitted.length - 1) {
      return [it];
    }
    return [
      it,
      <ChatMessageMention
        key="mention"
        userExternalId={matchedMentions[idx].externalId}
        content={matchedMentions[idx].mentioned}
        boxSx={sx}
      />,
    ];
  });
}
